import { Route, Routes } from 'react-router-dom';
import styled from 'styled-components';
import { Header } from './components/Headers';
import { Home } from './screens/Home';
import { About } from './screens/About';
import { Terms } from './screens/Terms';
import { Privacy } from './screens/Privacy';
import { Press } from './screens/Press';
import { Business } from './screens/Business';
import { Partnership } from './screens/Partnership';
import { Contact } from './screens/Contact';
import { GetMembership } from './screens/GetMembership';
import { CancelMembership } from './screens/CancelMembership';

export const App = () => {
	return (
		<AppBody>
			<Header />
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/about" element={<About />} />
				<Route path="/terms" element={<Terms />} />
				<Route path="/privacy" element={<Privacy />} />
				<Route path="/press" element={<Press />} />
				<Route path="/business" element={<Business />} />
				<Route path="/partnership" element={<Partnership />} />
				<Route path="/contact" element={<Contact />} />
				<Route path="/membership" element={<GetMembership />} />
				<Route path="/cancel" element={<CancelMembership />} />
			</Routes>
		</AppBody>
	);
};

const AppBody = styled.div`
	height: 100%;
`;
